module.exports = __webpack_public_path__ + "static/sergiler4-b0aa8381d1e3edf77bc8306d03d9286f.png";